import classNames from 'classnames';
import { MdClose } from 'react-icons/md';
import { useParams } from 'react-router-dom';

import { Button } from '~/components/ui/button';
import { BlurredOverlay } from '~/components/design/overlay/BlurredOverlay';
import { isAirportClient } from '~/config/airports.config';

import { useGlobalPopup } from './useGlobalPopup';
import styles from './GlobalPopup.module.css';

function ClosePopup({ className }: { className?: string }) {
    const { close } = useGlobalPopup();

    return <Button className={className} preset="secondary" icon={<MdClose />} onClick={close} />;
}

/**
 * Global popup component.
 * @example
 * ```tsx
 * function App() {
 *    const openPopup = useGlobalPopup((state) => state.open);
 *    return (
 *       <div>
 *         <GlobalPopup />
 *         <button onClick={() => openPopup(<div>Popup content</div>)}>Open popup</button>
 *      </div>
 *   );
 * }
 * ```
 * @returns the global popup component
 */
export function GlobalPopup() {
    const { clientID } = useParams();

    const content = useGlobalPopup((state) => state.content);

    const useAirportFullscreen = isAirportClient(clientID);

    const modalStyles = useAirportFullscreen ? styles.modalAirportFullscreen : styles.modal;

    return (
        <BlurredOverlay className={classNames(styles.container, content ? styles.show : styles.hide)}>
            <div className={modalStyles}>
                <ClosePopup className={classNames(styles.over, 'topRight')} />
                {content}
            </div>
        </BlurredOverlay>
    );
}
